import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import SmoothScroll from "@/components/SmoothScroll";
import PublicLayout from "@/components/PublicLayout";
import ProtectedRoute from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import Destinations from "@/pages/Destinations";
import Packages from "@/pages/Packages";
import PackageDetail from "@/pages/PackageDetail";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Pay from "@/pages/Pay";
import PaymentStatus from "@/pages/PaymentStatus";
import Gallery from "@/pages/Gallery";
import TrackBooking from "@/pages/TrackBooking";
import AdminLogin from "@/pages/admin/AdminLogin";
import Dashboard from "@/pages/admin/Dashboard";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <SmoothScroll>
          <Toaster position="top-center" richColors />
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/destinations" element={<Destinations />} />
              <Route path="/packages" element={<Packages />} />
              <Route path="/packages/:id" element={<PackageDetail />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/pay" element={<Pay />} />
              <Route path="/payment-status" element={<PaymentStatus />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/track" element={<TrackBooking />} />
            </Route>
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          </Routes>
        </SmoothScroll>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
